<div mat-dialog-content>
  <div class="row">
    <div class="col-6">
      <h2>Conditions d'utilisation</h2>
      <p>
        Veuillez lire l'intégralité de cette présente politique. En créant votre
        compte sur la plateforme d’évaluation de
        <strong>KortoJura inc.</strong>, vous confirmez votre acceptation de
        cette politique de confidentialité. Il s'agit d'un contrat entre vous et
        <strong>KortoJura inc.</strong> appliqué à votre accès à ses produits et
        services ainsi qu’à leur utilisation. Si vous n'acceptez pas cette
        politique, vous ne devez pas compléter la création de votre compte sur
        cette plateforme.
      </p>
      <h5>1. Propriété du contenu</h5>
      <p>
        Tous les documents affichés ou accessibles sur la plateforme de
        <strong>KortoJura</strong>, y compris, notamment, les textes, les
        graphiques, les vidéos, les photographies, les extraits sonores, les
        marques de commerce, les logos et d'autres objets (collectivement, le «
        contenu »), y compris le contenu créé avec les services ou soumis aux
        services par vous ou par l'intermédiaire de votre compte, sont protégés
        par les lois sur le droit d'auteur et sur les marques de commerce et
        appartiennent à <strong>KortoJura inc.</strong> et à ses concédants de
        licence ou à ses représentants autorisés à titre de fournisseur du
        contenu. Sous réserve des droits accordés par la présente licence
        restreinte, toute utilisation du contenu, y compris la modification, la
        transmission, la présentation, la distribution, la publication ou toute
        autre exploitation de la plateforme ou de son contenu, en totalité ou en
        partie, sans l'autorisation préalable et écrite de
        <strong>KortoJura</strong> est strictement interdite.
      </p>
      <h5>2. Cueillette et utilisation de l’information</h5>
      <p>
        KortoJura demande seulement les informations nécessaires à la
        réalisation de sa mission, plus particulièrement pour les raisons
        suivantes et dans les contextes suivants :
      </p>
      <ul>
        <li>
          <strong>Votre inscription à la plateforme (création de compte)</strong
          >: Nom, prénom, courriel et mot de passe
          <ul>
            <li>
              Vous seul pouvez accéder à votre compte à l’exception d’une tierce
              partie que vous aurez désignée, ainsi que
              <strong>KortoJura</strong>, pour des raisons administratives
              seulement.
            </li>
          </ul>
        </li>
        <li>
          <strong>Votre profil candidat </strong>: Titre, adresse complète,
          langue maternelle, langue officielle de communication préférée et
          profession ou occupation
          <ul>
            <li>
              Ceci est pour personnaliser votre expérience sur la plateforme
              d’évaluation (accessibilité à des tests pour la profession ou
              l’occupation désignée) et pour la gestion administrative de votre
              compte (facturation, etc.).
            </li>
          </ul>
        </li>
        <li>
          <strong>Votre profil professionnel et linguistique </strong>:
          <ul>
            <li>
              Ces données sont recueillies pour des fins de statistiques,
              d’évaluation du rendement, d’étude de clientèle et de marketing.
            </li>
          </ul>
        </li>
      </ul>
      <p>
        Vous êtes responsable de la gestion de votre compte et de sa mise à
        jour. Vous convenez donc que l’information associée à votre compte est
        juste et à jour
      </p>
      <p>
        En aucun cas <strong>KortoJura</strong> ne vendra, échangera ou
        divulguera votre information ou vos données à une tierce partie sans
        votre consentement, à moins d’une obligation légale. Vos données
        demeurent confidentielles.
      </p>
      <h5>3. Protection de l’information</h5>
      <p>
        <strong>KortoJura</strong> respecte la Loi sur la protection des
        renseignements personnels et prend les mesures adéquates pour assurer
        l’intégrité et la confidentialité de votre information.
      </p>
      <p>
        La plateforme d’évaluation est hébergée sur un environnement sécurisé
        derrière https et respecte les recommandations de sécurité des
        applications web. Les mots de passe sont également protégés et
        encryptés, et toute connexion à la plateforme exige la création d’un
        compte.
      </p>
      <p>
        Seul le personnel autorisé de <strong>KortoJura</strong> aura accès à
        votre information et, ce, seulement pour des fins administratives. Les
        membres du personnel acceptent, dans le cadre de leurs fonctions, la
        politique de confidentialité de l’entreprise.
      </p>
      <p>
        Votre information est conservée sur la plateforme pour la durée requise
        par les services offerts et tant que votre compte est ouvert.
      </p>
      <p>
        Lorsque le compte d’un utilisateur n’a pas été actif pendant la période
        d’une année, ce compte sera fermé d’office par KortoJura, sauf
        indication contraire donnée par l’utilisateur dans un délai de dix (10)
        jours suivant l’envoi à cet utilisateur d’un avis à cet effet par
        KortoJura.
      </p>
      <p>
        Ainsi, à moins d’obligation légale contraire, KortoJura supprimera et
        effacera toute information et documents d’information relatifs au compte
        de l’utilisateur sur fermeture de ce dernier
      </p>
      <p>
        Toute information collectée dans le cadre d’analyses statistiques peut
        être conservée pendant une période indéterminée. Cependant,
        l’utilisateur comprend et accepte que de tels rapports ne doivent en
        aucun cas permettre de l’identifier ou d’avoir accès à d’autres
        informations ne le concernant pas personnellement.
      </p>
      <p>
        <strong>KortoJura</strong> se réserve le droit de modifier ou mettre à
        jour cette politique sans préavis. La dernière date de modification de
        ce document est disponible en tout temps.
      </p>
    </div>
    <div class="col-6">
      <h2>Privacy Policy</h2>
      <p>
        Please read this policy in its entirety. By creating your account on
        <strong>KortoJura's</strong> evaluation platform, you confirm your
        acceptance of this privacy policy. This is a contract between you and
        <strong>KortoJura Inc.</strong> that applies to your access to and use
        of its products and services. If you do not agree to this policy, you
        should not complete the creation of your account on this platform.
      </p>
      <h5>1. Ownership of Content</h5>
      <p>
        All documents displayed or accessible on
        <strong>KortoJura's</strong> platform, including, without limitation,
        text, graphics, videos, photographs, sound clips, trademarks, logos and
        other objects (collectively, the "Content"), including content created
        with the services or submitted to the services by you or through your
        account, are protected by copyright and trademark laws and are owned by
        <strong>KortoJura Inc.</strong> and its licensors or authorized
        representatives as the content provider. Subject to the rights granted
        by this limited license, any use of the content, including the
        modification, transmission, presentation, distribution, publication or
        other exploitation of the platform or its content, in whole or in part,
        without the prior written consent of <strong>KortoJura</strong> is
        strictly prohibited.
      </p>
      <br />
      <br />
      <h5>2. Collection and Use of Information</h5>
      <p>
        <strong>KortoJura</strong> only requests the information necessary to
        carry out its mission, more particularly for the following reasons and
        in the following contexts:
      </p>
      <ul>
        <li>
          <strong>Your registration to the platform (account creation)</strong>:
          Last name, first name, email and password
          <ul>
            <li>
              Only you can access your account except for a third party you have
              designated, as well as <strong>KortoJura</strong>, for
              administrative purposes only
            </li>
          </ul>
        </li>
        <li>
          <strong>Your candidate profile</strong>: Title, full address, mother
          tongue, preferred official language of communication and profession or
          occupation
          <ul>
            <li>
              This is to personalize your experience on the evaluation platform
              (accessibility to tests for the designated profession or
              occupation) and for the administrative management of your account
              (billing, etc.).
            </li>
          </ul>
        </li>
        <li>
          <strong>Your professional and linguistic profile:</strong>
          <ul>
            <li>
              This data is collected for statistical, performance evaluation,
              customer research and marketing purposes.
            </li>
          </ul>
        </li>
      </ul>
      <p>
        You are responsible for managing your account and updating it. You
        therefore agree that the information associated with your account is
        accurate and up to date.
      </p>
      <p>
        Under no circumstances will <strong>KortoJura</strong> sell, trade or
        disclose your information or data to a third party without your consent,
        unless required by law. Your data remains confidential.
      </p>
      <h5>3. Protection of Information</h5>
      <p>
        <strong>KortoJura</strong> respects the Privacy Act and takes
        appropriate measures to ensure the integrity and confidentiality of your
        information.
      </p>
      <p>
        The evaluation platform is hosted on a secure environment behind https
        and complies with web application security recommendations. Passwords
        are also protected and encrypted, and any connection to the platform
        requires the creation of an account.
      </p>
      <p>
        Only authorized <strong>KortoJura</strong> staff will have access to
        your information and only for administrative purposes. Employees accept,
        as part of their duties, the company's privacy policy.
      </p>
      <p>
        Your information is kept on the platform for the duration required by
        the services offered and as long as your account is open.
      </p>
      <p>
        When a user's account has not been active for the one-year period, it
        will be automatically closed by <strong>KortoJura</strong>, unless
        otherwise specified by the user within ten (10) days of
        <strong>KortoJura</strong> sending a notice to this effect to that user
      </p>
      <p>
        Thus, unless otherwise required by law, <strong>KortoJura</strong> will
        delete and erase all information and information documents relating to
        the user's account upon the user's closure.
      </p>
      <p>
        Any information collected in the context of statistical analyses may be
        kept for an indefinite period of time. However, the user understands and
        accepts that such reports must under no circumstances allow him/her to
        be identified or to have access to other information that does not
        concern him/her personally.
      </p>
      <p>
        <strong>KortoJura</strong> reserves the right to change or update this
        policy without notice. The latest modification date of this document is
        available at any time.
      </p>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'Global.Close' | translate }}</button>
</div>
